export enum CustomizerInspirationStateConstants {
    NEW = "New",
    ADDED = "Added"
}
